import { render, staticRenderFns } from "./DropdownMultiple.vue?vue&type=template&id=3a5ba506&scoped=true&"
import script from "./DropdownMultiple.vue?vue&type=script&lang=js&"
export * from "./DropdownMultiple.vue?vue&type=script&lang=js&"
import style0 from "./DropdownMultiple.vue?vue&type=style&index=0&id=3a5ba506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5ba506",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VFlex})
